<template>
  <b-container fluid class="fp-container bg-white">
    <b-container class="py-5">
      <b-row>
        <b-col md="2" class="text-left">
        </b-col>
        <b-col md="8">
          <h1>Työkaluja puurakennushankkeen valmisteluun</h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="8" offset-md="2">
          <p class="text-left"><strong>ePuu</strong>-palvelulla voit selvittää, miten puurakennushanke poikkeaa muusta rakentamisesta ja selvittää hanketta koskevat palomääräykset. Lisäksi voit tutustua erilaisiin puurakennejärjestelmiin ja valita hankkeeseen soveltuvat vaatimusten mukaiset rakenneratkaisut. Voit myös katsoa, mitä vastaavat hankkeet Suomessa ovat aiemmin maksaneet ja löytää puisia ratkaisuja tarjoavat yritykset hankkeen kilpailutusta ja hankintoja varten.</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="8" offset-md="2">
          <iframe id="ytplayer" type="text/html" width="100%" height="420" src="https://www.youtube.com/embed/Wveir_yo4kE?autoplay=1&origin=http://epuu.fi" frameborder="0"></iframe>
        </b-col>
      </b-row>

      <b-row class="py-3">
        <b-col md="8" offset-md="2" class="text-left">
           <p><router-link to="/maaritelmia">Puurakentamista koskevia tärkeitä määritelmiä</router-link></p>
           <p><router-link to="/kayttoohje">Tutustu käyttöohjeisiin tarkemmin</router-link></p>
           <p><router-link to="/hyodyllisia-linkkeja">Hyödyllisiä linkkejä</router-link></p>
        </b-col>
      </b-row>

      <b-row class="py-3">
        <b-col md="8" offset-md="2" class="text-left">
          <router-link to="/hanke" class="button-orange">
            <font-awesome-icon icon="arrow-circle-right" class="icon"></font-awesome-icon> Aloita
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: 'Aloitus',
  data () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Aloitus.vue